<template>
  <div v-show="1 != 1">
    successAlert:{{ successAlert }}
    <br />
    successMessage:{{ successMessage }}
    <br />
    dangerAlert:{{ dangerAlert }}
    <br />
    dangerMessage:{{ dangerMessage }}
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "Alerts",
  data() {
    return {};
  },
  components: {
    Swal,
  },
  computed: {
    ...mapState({
      successAlert: "successAlert",
      successMessage: "successMessage",
      dangerAlert: "dangerAlert",
      dangerMessage: "dangerMessage",
    }),
  },
  methods: {},
  updated() {
    if (this.successAlert)
      Swal.fire({
        title: "موفق",
        text: this.successMessage,
        icon: "success",
        //iconHtml: "؟",
        confirmButtonText: "بله",
        //cancelButtonText: "خیر",
        //showCancelButton: true,
        showCloseButton: true,
      });
    if (this.dangerMessage)
      Swal.fire({
        title: "خطا",
        text: this.dangerMessage,
        icon: "error",
        //iconHtml: "؟",
        confirmButtonText: "بله",
        //cancelButtonText: "خیر",
        //showCancelButton: true,
        showCloseButton: true,
      });

    setTimeout(() => {
      this.$store.state.successAlert = false;
      this.$store.state.dangerMessage = false;
    }, 1000);
  },
};
</script>
